var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37737_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2775 29.8057C44.0722 42.663 31.0498 50.4877 18.191 47.2815C5.33764 44.0761 -2.48704 31.0529 0.719741 18.1967C3.92371 5.33806 16.946 -2.48721 29.8008 0.718162C42.6587 3.92353 50.4829 16.9481 47.2772 29.8059L47.2774 29.8057H47.2775Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6013 6.40002L23.3564 7.20218V30.4769L23.6013 30.7125L34.8016 24.3264L23.6013 6.40002Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.601 6.40002L12.4004 24.3264L23.601 30.7125V19.4156V6.40002Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6009 32.7581L23.4629 32.9204V41.2112L23.6009 41.5997L34.8081 26.3752L23.6009 32.7581Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.601 41.5997V32.7581L12.4004 26.3752L23.601 41.5997Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6016 30.7126L34.8019 24.3264L23.6016 19.4156V30.7126Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 24.3264L23.601 30.7126V19.4156L12.4004 24.3264Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37737_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.c2e96b0185447a496e8e72f28015a600.svg";
export { ForwardRef as ReactComponent };